import { ReactionKey } from "@lazarentertainment/public-chat-web"
import Emoji from "node-emoji"
import { MouseEventHandler } from "react"
import styled from "styled-components"

const ReactionCounterButtonWrapper = styled.button`
  --primary-color: #caedf8;
  --outline-color: var(--primary-color);
  --font-color: ${({ theme }) => theme.colors.darkMed};

  user-select: none;
  display: flex;
  align-items: center;
  grid-gap: 5px;
  padding: 2px 6px;
  border-radius: 14px;
  font-size: 12px;
  color: var(--font-color);
  border: 1px solid var(--outline-color);
  background: var(--primary-color);
  transition: transform 30ms ease-in;

  .emoji {
    font-size: 13px;
  }

  &[data-selected="true"] {
    background: none;
  }

  &[data-selected="true"][data-ondarkbackground="false"] {
    --outline-color: #b6d9e4;
  }

  &[data-ondarkbackground="true"] {
    --primary-color: ${({ theme }) => theme.colors.neutral};
  }

  &[data-ondarkbackground="true"][data-selected="true"] {
    --font-color: ${({ theme }) => theme.colors.neutral};
  }

  &:hover {
    transform: scale(1.05);
  }

  &:active {
    transform: scale(0.95);
  }

  &:disabled {
    color: unset;
  }
`

export type ChatReactionCounterButtonProps = {
  selected: boolean
  onDarkBackground?: boolean
  reactionKey: ReactionKey
  count: number
  onClick: MouseEventHandler<HTMLButtonElement>
}

export const ChatReactionCounterButton = ({
  selected,
  onDarkBackground = false,
  reactionKey,
  count,
  onClick,
}: ChatReactionCounterButtonProps) => {
  const emoji = Emoji.get(reactionKey)

  if (!emoji) {
    return null
  }

  return (
    <ReactionCounterButtonWrapper
      data-selected={selected}
      data-ondarkbackground={onDarkBackground}
      onClick={onClick}
      data-robot={`message-reaction-counter-${reactionKey}`}
    >
      <span className="emoji">{emoji}</span>
      <span className="count">{count}</span>
    </ReactionCounterButtonWrapper>
  )
}
